/**
 * Registry de componentes de missão do jogo ATLAS.
 *
 * Mapeia missionId (do manifest) → MissionRegistration. O resolver federado
 * em registry/componentRegistry.ts consome este mapa via NAMESPACE_MAP.atlas.
 * Todas as 6 missões do ATLAS v1 portadas — os originais em
 * src/test/atlas-lab/missoes/ continuam intactos (sandbox/referência).
 *
 * masterPanel fica undefined em todas as missões atlas.* (v1.1 não tinha
 * painel dedicado). Componentes novos lab.* (PR-2+) podem registrar painéis
 * específicos por tipo (histograma, agrupamento, lista).
 */

import type { ComponentType } from 'react'

import { Assinaturas } from './Assinaturas'
import { HypatiaMomentoTransverso } from './HypatiaMomentoTransverso'
import { HypatiaReal } from './HypatiaReal'
import { HypatiaTutorial } from './HypatiaTutorial'
import { Identificacao } from './Identificacao'
import { MassaInvariante } from './MassaInvariante'
import { Reconhecimento } from './Reconhecimento'

export interface MissionComponentProps {
  currentActivityId?: string | null
  onLayerFocused?: (layer: string) => void
  onMissionEvent?: (verb: string, payload: Record<string, unknown>) => void
  readOnly?: boolean
  // Estendidos no PR-1 (SPEC-ATLAS-V2): em PR-1 nenhum desses é populado
  // pelo MissionSlide, exceto membershipId (vem do useSessionState).
  // PR-2 popula pairedResponse via sessionSnapshot; PR-3 popula myAssignment
  // e myTeam via LabCollaborativeAssignment + send_to_membership.
  myAssignment?: Record<string, unknown>
  myTeam?: string
  membershipId?: string | null
  pairedResponse?: Record<string, unknown>
  /**
   * Configuração do slide vinda do manifest (frontmatter YAML inteiro,
   * incluindo prompt, pairId, fields, etc). Usada pelos componentes lab.*
   * que precisam acessar declarações do autor. Componentes atlas.* ignoram.
   */
  slideConfig?: Record<string, unknown>
  /** Índice do slide na sessão — necessário pros submits dos componentes lab.*. */
  slideIndex?: number
}

interface MissionRegistration {
  component: ComponentType<MissionComponentProps>
  masterPanel?: ComponentType<MissionComponentProps>
}

export const ATLAS_COMPONENTS: Record<string, MissionRegistration> = {
  'atlas.reconhecimento': { component: Reconhecimento as ComponentType<MissionComponentProps> },
  'atlas.assinaturas': { component: Assinaturas as ComponentType<MissionComponentProps> },
  'atlas.identificacao': { component: Identificacao as ComponentType<MissionComponentProps> },
  'atlas.massainvariante': { component: MassaInvariante as ComponentType<MissionComponentProps> },
  'atlas.hypatia.tutorial': { component: HypatiaTutorial as ComponentType<MissionComponentProps> },
  'atlas.hypatia.momentoTransverso': { component: HypatiaMomentoTransverso as ComponentType<MissionComponentProps> },
  'atlas.hypatia.real': { component: HypatiaReal as ComponentType<MissionComponentProps> },
}
